/* eslint-disable react/prop-types */
// Imports
import React from "react";
import {useQuiz} from "src/contexts/QuizContext";

// Get quiz answers from context

// Define bars
const bars = [{title:"Driving frequency", dependentOnQs :[2] },
{title:"Driving confidence", dependentOnQs: [5]},
{title:"Vehicle safety", dependentOnQs:[14,15] },
{title:"Access to public transport", dependentOnQs:[2,3] },
{title:"Health and driving", dependentOnQs:[8,9,10] },
{title:"Driving safety", dependentOnQs:[13,16] }]


const barInfo = (data) => bars.map(bar => {
        return {
            title: bar.title,
            answers: bar.dependentOnQs.map(q => data.find(answer => answer.questionId === q)),
            }
        })

// custom scoring as per https://squizgroup.atlassian.net/browse/TACSRUSAE-6

let results = {
  "Driving frequency": 0,
  "Driving confidence": 0,
  "Vehicle safety": 0,
  "Access to public transport": 0,
  "Health and driving": 0,
  "Driving safety": 0
};

const generateBarResults = (barData) => {
    const answersLog = [];

    barData.map((bar) => {
    
        if (bar.title === "Driving frequency") {
            const driveFreqAnswer = bar.answers[0].answers.find(
            (el) => el?.sectionId == 1
            ).answer;
            
            answersLog.push({
                title: "Driving frequency",
                value: driveFreqAnswer
            });
            
            const driveFreqScoring = {
                Daily: 1,
                "2-3 times a week": 0.83,
                "Once a week": 0.67,
                Monthly: 0.5,
                "Less often": 0.33,
                Never: 0.17
            };

            if (driveFreqAnswer) {
            results[bar.title] = driveFreqScoring[driveFreqAnswer];
            }
        }

        if (bar.title === "Driving confidence") {
            const driveConfAnswers = bar.answers[0]?.answers;

            driveConfAnswers?.forEach((item)=>{
                answersLog.push({
                    title: `Driving confidence - ${item.sectionTitle}`,
                    value: item.answer
                });
            });

            const drivingConfScoring = {
                Nervous: 1,
                "I avoid it": 1,
                Neutral: 10,
                Comfortable: 10,
                "Very comfortable": 10
            };

            if (driveConfAnswers) {
            const driveConfScoreTally = driveConfAnswers.reduce(
                (sum, item) => sum + drivingConfScoring[item.answer],
                0
            );

            results[bar.title] = driveConfScoreTally / 40;
            }
        }

        if (bar.title === "Vehicle safety") {
            const vehicleSafetyAnswers = bar?.answers;

            let vehicleSafetyScoreTally = 0;

            vehicleSafetyAnswers.forEach((q) => {
            if (q.questionId === 14) {
                let carAge = q.answers[0].answer;
                if (carAge === "Ten years or older") {
                vehicleSafetyScoreTally += 0.2;
                } else if (carAge === "At least five but less than 10 years old") {
                vehicleSafetyScoreTally += 0.4;
                } else if (carAge === "Less than five years old") {
                vehicleSafetyScoreTally += 0.6;
                }
                
                answersLog.push({
                    title: "Vehicle safety - Car age",
                    value: carAge
                });
            }

            if (q.questionId === 15) {
                let newCar = q.answers[0].answer;
                if (newCar === "No") {
                vehicleSafetyScoreTally += 0.2;
                } else if (newCar === "Yes") {
                vehicleSafetyScoreTally += 0.4;
                }
                
                answersLog.push({
                    title: "Vehicle safety - New car consideration",
                    value: newCar
                });
            }
            });
            results[bar.title] = vehicleSafetyScoreTally;
        }

        if (bar.title === "Access to public transport") {
            
            let accessToPublicTransportTally = 0;

            //q2 section 6
            const accessToPubTranAnswerQ2 = bar.answers.find(
            (el) => el?.questionId == 2
            )?.answers;
            const accessToPubTranAnswerQ2Section6 = accessToPubTranAnswerQ2?.find(
            (el2) => el2?.sectionId == 6
            )?.answer;

            answersLog.push({
                title: "Access to public transport - Usage frequency",
                value: accessToPubTranAnswerQ2Section6
            });

            const accessPublicTransScoring = {
                Daily: 1,
                "2-3 times a week": 0.75,
                "Once a week": 0.5,
                Monthly: 0,
                "Less often": 0,
                Never: 0
            };

            if (accessToPubTranAnswerQ2Section6) {
            accessToPublicTransportTally +=
                accessPublicTransScoring[accessToPubTranAnswerQ2Section6];
            }

            // q 3
            const accessToPubTranAnswerQ3 = bar.answers.find(
            (el) => el?.questionId == 3
            )?.answers[0]?.answer;

            answersLog.push({
                title: "Access to public transport - Feel able to access",
                value: accessToPubTranAnswerQ3
            });
            
            if (accessToPubTranAnswerQ3 === "Yes") {
            accessToPublicTransportTally += 0.5;
            }

            results[bar.title] = accessToPublicTransportTally;
        }

        if (bar.title === "Health and driving") {
            let healthDrivingTally = 0;

            //q8
            const medicalConditionAnswer = bar.answers.find(
            (el) => el?.questionId == 8
            )?.answers[0]?.answer;
            
            answersLog.push({
                title: "Health and driving - Chronic medical conditions",
                value: medicalConditionAnswer
            });

            if (medicalConditionAnswer === "No") {
                healthDrivingTally += 0.5;
            }

            //q9
            const eyeTestAnswer = bar.answers.find((el) => el?.questionId == 9)
            .answers[0].answer;
            
            answersLog.push({
                title: "Health and driving - Eye test in last 2 years",
                value: eyeTestAnswer
            });
            
            if (eyeTestAnswer === "Yes") {
                healthDrivingTally += 0.25;
            }

            //q10
            const drDiscussAnswer = bar.answers.find((el) => el?.questionId == 10)
            .answers[0].answer;
            
            answersLog.push({
                title: "Health and driving - Discuss medication effects with doctor",
                value: drDiscussAnswer
            });
            
            if (drDiscussAnswer === "Yes") {
                healthDrivingTally += 0.25;
            }

            results[bar.title] = healthDrivingTally;
        }

        if (bar.title === "Driving safety") {
            let drivingSafetyTally = 0;      
            // q13
            const concernDriving = bar.answers.find((el) => el?.questionId == 13)
            .answers[0].answer;
            
            answersLog.push({
                title: "Driving safety - Others expressed concern about driving",
                value: concernDriving
            });
            
            if(concernDriving === "No"){
                drivingSafetyTally += 0.5;
            }
            
            // q16
            const concernOthersDriving = bar.answers.find((el) => el?.questionId == 16)
            .answers[0].answer;
            
            answersLog.push({
                title: "Driving safety - Concerns about others' driving",
                value: concernOthersDriving
            });
            
            if(concernOthersDriving === "No"){
                drivingSafetyTally += 0.5;
            }
            
            results[bar.title] = drivingSafetyTally;
        }
    });

    // console.table(answersLog);

    return barData;
}
        
        
const RecBars = () => {
    const {quizAnswers} = useQuiz();

    const barData = barInfo(quizAnswers);

    generateBarResults(barData);

         return (
            <div className="rec-bars">
                <h2 className="rec-bars__title">Your results from the quiz:</h2>
                
                <div className="rec-bars__content">
                    {Object.entries(results).map(([category, score]) => (
                        <div key={category} className="rec-bars__bar-item">
                            <div className="rec-bars__bar-label">
                                <span className="rec-bars__bar-name">{category}</span>
                                {/* <span className="rec-bars__bar-value">
                                    {Math.round(score * 100)}%
                                </span> */}
                            </div>
                            <div className="rec-bars__bar-container">
                                <div 
                                    className="rec-bars__bar-fill"
                                    style={{
                                        width: `${score ? score * 100 : 10}%`}}
                                />
                            </div>
                        </div>
                    ))}
                </div>
                
                {/* Debug info */}
                {/* <details className="rec-bars__debug">
                    <summary>Debug: Raw Results</summary>
                    <pre>{JSON.stringify(results, null, 2)}</pre>
                </details> */}
            </div>
   );
};

export default RecBars;
